<template>
  <div
    v-if="active"
    class="page-editor__container"
  >
    <div
      class="dropzone"
      :class="{'dropzone--active': active}"
      @dragover.prevent
      @drop.stop="$emit('drop', { event: $event, index: index})"
    >
      Drop here
    </div>
  </div>
</template>
<style>
  .dropzone{
    border: 1px dashed #979797;
    border-radius: 3px;
    background-color: rgba(0,0,0,0.05);
    text-align: center;
    font-family: "Open Sans";
    font-size: 0.625rem;
    padding: 15px 0;
    text-transform: uppercase;
  }
  .dropzone--active{
    background-color: rgba(255,0,0,0.05);
  }
</style>
<script>
export default {
  name: 'Dropzone',
  props: ['active', 'index'],
};
</script>
